/* Winkelmand-drawer, het kleine beetje gedrag dat de server niet kan doen.

   De drawer haalt zichzelf bij elke wijziging opnieuw op bij Shopify en
   wisselt het resultaat in. Alles wat je ziet is dus server-side gerenderd
   en klopt na elke plus, min en verwijdering, zonder dat dit bestand iets
   hoeft na te rekenen. Wat hier staat is beperkt tot drie dingen die pas
   in de browser gebeuren:

   1. de ondergrens bewaken als iemand een aantal intypt in plaats van de
      knoppen te gebruiken;
   2. de ondervloer toevoegen vanuit de herinnering;
   3. het akkoordvinkje en de bestelknop op elkaar aansluiten.

   Omdat de inhoud van de drawer telkens wordt vervangen, hangt alles aan
   een gedelegeerde luisteraar op document. Luisteraars op de elementen
   zelf zouden bij de eerste verversing verdwijnen. */
(function () {
  'use strict';

  function tekst(sleutel, terugval) {
    var bron = window.SolzaCartTeksten || {};
    return bron[sleutel] || terugval;
  }

  /* ---------- 1. ondergrens bij typen ----------

     De plus- en minknoppen van het theme gebruiken stepUp en stepDown, en
     die houden zich vanzelf aan het min-attribuut. Typen doet dat niet: wie
     4 weghaalt en 1 intypt, komt onder de minimale afname uit. Daarom hier
     een klem, op change en niet op input -- tijdens het typen is het veld
     even leeg of half af, en dan zou de klem het getal onder je vingers
     vandaan veranderen. */
  document.addEventListener(
    'change',
    function (e) {
      var veld = e.target;
      if (!veld || !veld.classList || !veld.classList.contains('m-quantity__input')) return;

      var min = parseInt(veld.getAttribute('min'), 10);
      if (!min || min < 1) return;

      var waarde = parseInt(veld.value, 10);
      if (isNaN(waarde) || waarde >= min) return;

      veld.value = min;
    },
    true /* in de capture-fase, zodat de klem klaar is voordat het theme de
            nieuwe waarde naar Shopify stuurt */
  );

  /* ---------- 2. de ondervloer toevoegen ---------- */

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-solza-nudge-toevoegen]');
    if (!knop || knop.disabled) return;

    e.preventDefault();
    knop.disabled = true;
    knop.textContent = tekst('nudge_bezig', knop.textContent);

    var lichaam = {
      items: [
        {
          id: parseInt(knop.dataset.variant, 10),
          quantity: parseInt(knop.dataset.aantal, 10) || 1
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lichaam)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('toevoegen mislukt');
        return r.json();
      })
      .then(function () {
        /* De drawer opnieuw laten ophalen. Daarmee verdwijnt deze
           herinnering vanzelf, want de voorwaarde eronder klopt niet meer.
           Zelf het blok weghalen zou sneller ogen maar laat de rest van de
           mand achter met verouderde bedragen. */
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
          drawer.onCartDrawerUpdate();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        /* Mislukt het, dan gaat de knop terug naar zijn oude staat. Een
           knop die op "bezig" blijft hangen laat de klant wachten op iets
           dat niet meer komt. */
        knop.disabled = false;
        knop.textContent = tekst('nudge_knop', 'Toevoegen');
      });
  });

  /* ---------- 3. akkoordvinkje en bestelknop ---------- */

  function zetKnopstand(vinkje) {
    var doos = vinkje.closest('[data-solza-akkoord]');
    if (!doos) return;
    var wikkel = doos.parentElement;
    var knop = wikkel && wikkel.querySelector('[data-solza-bestel]');
    if (!knop) return;

    if (vinkje.checked) {
      knop.classList.remove('solza-cartfoot__bestel--wacht');
      knop.removeAttribute('aria-disabled');
      doos.classList.remove('solza-cartfoot__akkoord--vraagt');
    } else {
      knop.classList.add('solza-cartfoot__bestel--wacht');
      knop.setAttribute('aria-disabled', 'true');
    }
  }

  document.addEventListener('change', function (e) {
    var vinkje = e.target.closest && e.target.closest('[data-solza-akkoord-vinkje]');
    if (vinkje) zetKnopstand(vinkje);
  });

  /* Een te vroege klik. De knop is bewust niet disabled: uitgeschakeld
     vertelt niets en is met een schermlezer niet eens te vinden. Nu licht
     het vinkje op en springt de focus erheen, zodat duidelijk is wat er nog
     moet gebeuren. Geen browsermelding: die staat buiten de pagina en zegt
     niet waar je moet kijken. */
  document.addEventListener(
    'click',
    function (e) {
      var knop = e.target.closest && e.target.closest('[data-solza-bestel]');
      if (!knop || knop.getAttribute('aria-disabled') !== 'true') return;

      e.preventDefault();
      e.stopPropagation();

      var wikkel = knop.closest('.solza-cartfoot__knopwikkel');
      var doos = wikkel && wikkel.parentElement.querySelector('[data-solza-akkoord]');
      if (!doos) return;

      doos.classList.remove('solza-cartfoot__akkoord--vraagt');
      void doos.offsetWidth;
      doos.classList.add('solza-cartfoot__akkoord--vraagt');

      /* De focus naar het vinkje zelf. Dat staat onzichtbaar maar wel in
         de tabvolgorde, dus focus() werkt en de getekende doos licht mee
         op via focus-visible. Lukt het niet, dan is er niets kapot: de
         doos licht sowieso al op. */
      var vinkje = doos.querySelector('[data-solza-akkoord-vinkje]');
      if (vinkje) {
        try {
          vinkje.focus({ preventScroll: false });
        } catch (fout) {
          /* oudere browsers kennen de optie niet */
          vinkje.focus();
        }
      }
    },
    true
  );
})();
